/*
 * @Author: liukai
 * @since: 2022-04-21 14:07:38
 * @LastAuthor: liukai
 * @lastTime: 2022-04-21 14:07:39
 */
function checkDevice() {
    // js判断是否是苹果设备
    function checkIsAppleDevice() {
      var u = navigator.userAgent;
      var app = navigator.appVersion;
      var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      if (ios || iPad || iPhone) {
        return true;
      } else {
        return false;
      }
    }
    //js判断是否为Android设备
    function checkIsAndroidDevice() {
      var u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
        return true;
      } else {
        return false;
      }
    }
  
    if (checkIsAppleDevice()) {
      return "ios";
    } else {
      return "andriod";
    }
  }
  export default checkDevice;
  